import { createContext } from 'react';
import type { FamilyMember } from '../api/familyApi';

export interface FamilyContextValue {
  /** Currently viewed user ID (self or a family member) */
  activeUserId: string | null;
  /**
   * Switch the active profile. Returns a promise that resolves **after** the
   * backend acting-scoped /family/members response has replaced the in-memory
   * tree, so callers can await it to avoid intermediate "old id + new tree"
   * or "new id + old tree" flicker.
   */
  setActiveUserId: (id: string | null) => Promise<void>;
  /** Self + linked family members */
  familyMembers: FamilyMember[];
  loading: boolean;
  /**
   * True while a profile switch is in-flight. Consumers can freeze avatars /
   * names / banners during this window to avoid multiple UI updates per
   * switch.
   */
  isSwitching: boolean;
  refreshFamilyMembers: () => Promise<void>;
  /** Self (primary account holder) */
  selfMember: FamilyMember | null;
}

export const FamilyContext = createContext<FamilyContextValue | null>(null);
